import {
  buildTransactionFeeMap,
  TransactionFeeMap,
} from '@/utils/transaction-fees';
import { getTrueTime } from '@/utils/true-time';
import { gql } from '@apollo/client';
import { useMemo } from 'react';
import { useWrappedQuery } from './use-wrapped-query';

const SUPPLIER_CHATS_TRANSACTION_FEES_QUERY = gql`
  query UseTransactionFees_SupplierChats(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    businesses_by_pk(uuid: $supplierUUID) {
      supplier_chats(
        limit: 1
        where: { restaurant_uuid: { _eq: $restaurantUUID } }
      ) {
        flat_transaction_fees
        transaction_fees
        uuid
      }
      supplier_metadata {
        flat_transaction_fees
        gross_up_transaction_fees_cutoff
        transaction_fees
        uuid
      }
      uuid
    }
  }
`;

export const useTransactionFees = (
  restaurantUUID: string,
  supplierUUID: string,
) => {
  const { data } = useWrappedQuery(SUPPLIER_CHATS_TRANSACTION_FEES_QUERY, {
    variables: {
      restaurantUUID,
      supplierUUID,
    },
  });

  const transactionFeeMap: TransactionFeeMap = useMemo(() => {
    const supplier = data?.businesses_by_pk;

    return buildTransactionFeeMap(
      supplier?.supplier_metadata,
      supplier?.supplier_chats[0],
    );
  }, [data]);

  const grossUpTransactionFeesCutoff =
    data?.businesses_by_pk?.supplier_metadata
      ?.gross_up_transaction_fees_cutoff ?? null;
  const isGrossUpTransactionFee =
    !!grossUpTransactionFeesCutoff &&
    getTrueTime() >= new Date(grossUpTransactionFeesCutoff).getTime();

  return {
    isGrossUpTransactionFee,
    transactionFeeMap,
  };
};
